import React, { useState, useEffect } from "react";
import Modal from "./Modal";
import Button from "./Buttons";

/**
 * Records a posture finding as "not a risk" (§7a.3).
 *
 * The reason is mandatory because it is the entire accountability record for this decision —
 * unlike accepting a risk, nobody approves it. The copy is explicit that the judgement is not
 * permanent: it retires itself when the evidence behind the finding changes.
 */
export default function AiSuppressRiskModal({ isOpen, risk, onClose, onConfirm, isBusy = false }) {
  const [reason, setReason] = useState("");

  useEffect(() => { if (isOpen) setReason(""); }, [isOpen]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Record as not a risk" size="md">
      <div>
        <p className="text-sm text-content-primary mb-3">
          <span className="font-medium">{risk?.title}</span>
        </p>
        <p className="text-sm text-content-secondary mb-4">
          The risk closes now, and Axaris stops re-raising it on future scans. It is not permanent:
          if the evidence behind the finding changes — the agent gains a tool, or a new permission —
          the decision retires itself and the risk comes back.
        </p>

        <label className="block text-sm font-medium text-content-primary mb-1">
          Why is this not a risk? <span className="text-red-500">*</span>
        </label>
        <textarea
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          rows={3}
          autoFocus
          placeholder="e.g. Reviewed with the owning team — the mailbox this agent writes to is internal only."
          className="w-full text-sm border border-border rounded-lg px-3 py-2 bg-theme-primary text-content-primary focus:outline-none focus:ring-2 focus:ring-indigo-500"
        />
        <p className="text-xs text-content-secondary mt-1 mb-6">
          Recorded with your name on the asset's activity trail. Nobody else reviews this, so the
          reason is the record.
        </p>

        <div className="flex justify-end space-x-3">
          <Button variant="secondary" onClick={onClose}>Cancel</Button>
          <Button
            variant="primary"
            disabled={isBusy || !reason.trim()}
            onClick={() => onConfirm(reason.trim())}
          >
            {isBusy ? "Working…" : "Record as not a risk"}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
